import { jsxs, jsx } from "react/jsx-runtime";
import "react";
import PropTypes from "prop-types";
import MaximizeIcon from "../resources/Maximise.png.js";
const ChatBar = (props) => {
  if (props.show === false) {
    return null;
  }
  return /* @__PURE__ */ jsxs(
    "button",
    {
      id: "chat-bar-button",
      className: "light-red-gradient",
      onClick: props.onClick,
      children: [
        "Chat about this delivery",
        /* @__PURE__ */ jsx("img", { alt: "Maximize Chat", src: MaximizeIcon })
      ]
    }
  );
};
ChatBar.propTypes = {
  show: PropTypes.bool,
  businessUnit: PropTypes.number,
  onClick: PropTypes.func
};
export {
  ChatBar as default
};
//# sourceMappingURL=ChatBar.js.map
